module.exports = __webpack_public_path__ + "img/customer_nv.d87d4671.jpeg";